var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useMemo, useRef } from 'react';
import { Route, Routes as RouterSwitch, useNavigate } from 'react-router-dom';
import UserIcon from '@mui/icons-material/SupervisedUserCircleRounded';
import UnlockIcon from '@mui/icons-material/LockOpenRounded';
import LockIcon from '@mui/icons-material/LockRounded';
import LampIcon from '@mui/icons-material/WbIncandescentRounded';
import LampOffIcon from '@mui/icons-material/BlurOffRounded';
import ActivityIcon from '@mui/icons-material/TrendingUpRounded';
import WarningIcon from '@mui/icons-material/WarningRounded';
import TimerIcon from '@mui/icons-material/AvTimerRounded';
import { Typography, Button, List, ListItem, ListItemIcon, ListItemText, Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Switch, Box, } from '@mui/material';
import ButtonCard from '../../Components/ButtonCard';
import Loading from '../../Components/Loading';
import Transition from '../../Components/Transition';
import Wrapper from '../../Components/Wrapper';
import Header from '../../Components/Header/Header';
import GoBack from '../../Components/GoBack';
import { useSnackbar } from 'notistack';
import { useStyles } from './MyStorage.styles';
import { useApiFetch } from '../../Api';
import { useUserContext } from '../../Context/UserContext';
import { useApi } from '../../Context/APIContext';
import { Features, hasPermission } from '../../Auth/Features';
import useApiAbort from '../../Api/Core/useApiAbort';
import IconCard from '../../Components/ButtonCard/IconCard/IconCard';
import StorageActivity from './StorageActivity/StorageActivity';
import { isLarge, isMedium } from '../../assets/containerSizes/containerSizes';
import { large, medium, small } from '../../assets/Text/Text';
import StorageUsers from './StorageUsers';
import HTTP401 from '../../Features/Errors/HTTP401';
import { getAppConfiguration } from '../../Config';
import { useParams } from 'react-router-dom';
import { add, format, isAfter } from 'date-fns';
import { sv } from 'date-fns/locale';
const errorInfo = {};
const fetchStorageInfo = (api, storageId) => __awaiter(void 0, void 0, void 0, function* () {
    if (api && storageId) {
        var response = yield api.getStorageInfo(storageId);
        return response.info;
    }
    else {
        return undefined;
    }
});
const SwitchOption = (props) => {
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, { disableGutters: true },
            React.createElement(ListItemIcon, { sx: classes.switch },
                React.createElement(Switch, { color: "primary", onChange: props.onChange, checked: props.checked, inputProps: { 'aria-labelledby': 'switch-list-label-wifi' } })),
            React.createElement(ListItemText, { primary: props.name, secondary: props.description })),
        React.createElement(Divider, null)));
};
const Settings = (props) => {
    const classes = useStyles();
    const cancelDateFormatted = format(new Date(props.cancelDate), 'PPP', { locale: sv });
    const expirationDateFormatted = format(new Date(props.expirationDate), 'PPP', { locale: sv });
    const [checked, setChecked] = React.useState(['wifi']);
    const getSize = () => {
        if (props.storageInfo.volume) {
            if (isLarge(props.storageInfo.volume)) {
                return large;
            }
            if (isMedium(props.storageInfo.volume)) {
                return medium;
            }
            else {
                return small;
            }
        }
        return '';
    };
    const currentDate = new Date();
    const rentalStartDate = new Date(props.storageInfo.startDate);
    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];
        if (currentIndex === -1)
            newChecked.push(value);
        else
            newChecked.splice(currentIndex, 1);
        setChecked(newChecked);
    };
    return (React.createElement(Box, { component: "div", sx: classes.settings },
        React.createElement(Box, { component: "div", sx: classes.googleMaps },
            React.createElement("iframe", { title: "map", src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2135.43403888744!2d11.95261881616312!3d57.6411083811003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464ff28be1c39e51%3A0x59433d58ff9a8e82!2sDatav%C3%A4gen%202%2C%20436%2032%20Askim!5e0!3m2!1sen!2sse!4v1576824633687!5m2!1sen!2sse", width: "100%", height: "100%", frameBorder: "0" })),
        props.storageInfo.subscriptionId && (React.createElement(Box, { component: "div", sx: classes.box },
            React.createElement(Typography, { variant: "h4", sx: classes.header }, "Abonnemang"),
            React.createElement(Typography, null,
                "#",
                props.storageInfo.orderReference))),
        React.createElement(Box, { component: "div", sx: classes.box },
            React.createElement(Typography, { variant: "h4", sx: classes.header }, "Utrymme"),
            React.createElement(Typography, null,
                props.storageInfo.containerCode,
                " - ",
                props.storageInfo.storageCode),
            React.createElement(Typography, null, props.storageInfo.facilityLevel)),
        React.createElement(Box, { component: "div", sx: classes.box },
            React.createElement(Typography, { variant: "h4", sx: classes.header },
                "Storlek (",
                getSize(),
                ")"),
            props.storageInfo.height && (React.createElement(Typography, null,
                "H\u00F6jd: ",
                props.storageInfo.height,
                " ",
                props.storageInfo.unit)),
            props.storageInfo.length && (React.createElement(Typography, null,
                "L\u00E4ngd: ",
                props.storageInfo.length,
                " ",
                props.storageInfo.unit)),
            props.storageInfo.width && (React.createElement(Typography, null,
                "Bredd: ",
                props.storageInfo.width,
                " ",
                props.storageInfo.unit))),
        React.createElement(Box, { component: "div", sx: classes.box },
            React.createElement(Typography, { variant: "h4", sx: classes.header }, "Address"),
            React.createElement(Typography, null, props.storageInfo.facilityAddress),
            React.createElement(Typography, null,
                props.storageInfo.facilityPostalCode,
                " ",
                '',
                " ",
                props.storageInfo.facilityCity)),
        React.createElement(Box, { component: "div", sx: classes.box },
            React.createElement(Typography, { variant: "h4", sx: classes.header }, "Startdatum"),
            React.createElement(Typography, null, format(new Date(props.storageInfo.startDate), 'PP', { locale: sv }))),
        props.storageInfo.price &&
            props.storageInfo.billingFrequency !== "Icke \u00E5terkommande" /* NonRecurringName */ && (React.createElement(Box, { component: "div", sx: classes.box },
            React.createElement(Typography, { variant: "h4", sx: classes.header }, "Betalning"),
            React.createElement(Typography, null,
                props.storageInfo.price,
                " ",
                props.storageInfo.currency,
                " /",
                ' ',
                props.storageInfo.billingFrequency),
            React.createElement(Typography, { variant: "caption" },
                "Senaste betalning giltig till:",
                React.createElement("br", null),
                format(new Date(props.storageInfo.expirationDate), 'PP', { locale: sv })))),
        props.storageInfo.price &&
            props.storageInfo.billingFrequency === "Icke \u00E5terkommande" /* NonRecurringName */ &&
            rentalStartDate <= currentDate && (React.createElement(Box, { component: "div", sx: classes.box },
            React.createElement(Typography, { variant: "h4", sx: classes.header }, "Betald"),
            React.createElement(Typography, null,
                props.storageInfo.price.toFixed(2),
                " ",
                props.storageInfo.currency),
            "Utrymmet \u00E4r betalt och \u00E4r tillg\u00E4ngligt f\u00F6r dig fram till den\u00A0",
            format(new Date(props.storageInfo.expirationDate), 'PP', { locale: sv }))),
        props.storageInfo.price &&
            props.storageInfo.billingFrequency === "Icke \u00E5terkommande" /* NonRecurringName */ &&
            rentalStartDate > currentDate && (React.createElement(Box, { component: "div", sx: classes.box },
            React.createElement(Typography, { variant: "h4", sx: classes.header }, "Betald"),
            React.createElement(Typography, null,
                props.storageInfo.price.toFixed(2),
                " ",
                props.storageInfo.currency),
            "Utrymmet \u00E4r betalt och \u00E4r tillg\u00E4ngligt f\u00F6r dig fr\u00E5n och med den",
            ' ',
            format(new Date(props.storageInfo.startDate), 'PP', { locale: sv }),
            " fram till den",
            ' ',
            format(new Date(props.storageInfo.expirationDate), 'PP', { locale: sv }))),
        props.setts.length > 0 && (React.createElement(Box, { component: "div", sx: classes.box },
            React.createElement(Typography, { variant: "h4", sx: classes.header }, "Till\u00E4gg"),
            React.createElement(List, null, props.setts.map(s => (React.createElement(SwitchOption, { key: s.id, name: s.name, description: s.description, checked: checked.indexOf(s.id) !== 1, onChange: handleToggle(s.id) })))))),
        !props.hideCancel &&
            props.storageInfo.subscriptionId &&
            props.storageInfo.billingFrequency !== "Icke \u00E5terkommande" /* NonRecurringName */ && (React.createElement(React.Fragment, null,
            React.createElement(Button, { sx: classes.emptyStorage, variant: "outlined", color: "primary", disabled: props.loading || !!props.cancelDate, onClick: props.onClickCancel }, "Avsluta abonnemang"),
            props.loading ? (React.createElement(Loading, { size: 25 })) : (React.createElement(Typography, { sx: classes.caption, variant: "caption" }, props.cancelDate
                ? `Abonnemanget avslutades den ${cancelDateFormatted} och löper ut den ${expirationDateFormatted}.`
                : 'Tryck här när du vill avsluta ditt abonnemang.'))))));
};
const ConfirmDialog = (props) => {
    const expirationDateFormatted = format(new Date(props.expirationDate), 'PPP', { locale: sv });
    const classes = useStyles();
    const onAccept = () => {
        props.onConfirm();
        props.closeDialog();
    };
    return (React.createElement(Dialog, { open: props.open, onClose: props.closeDialog, "aria-labelledby": "end-subscribtion-storage-dialog-title", "aria-describedby": "end-subscribtion-storage-dialog-description" },
        React.createElement(DialogTitle, { id: "end-subscribtion-storage-dialog-title" },
            React.createElement(Typography, { variant: "subtitle1" }, "Avsluta abonnemang")),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { id: "end-subscribtion-storage-dialog-description" }, 'Ditt abonnemang kommer att löpa ut ' + expirationDateFormatted + '.')),
        React.createElement(DialogActions, { sx: classes.dialogActions },
            React.createElement(Button, { variant: "outlined", onClick: props.closeDialog, sx: classes.button }, "Nej, jag vill inte avsluta."),
            React.createElement(Button, { variant: "contained", onClick: onAccept, color: "primary", autoFocus: true, sx: classes.button }, "Ja, jag vill avsluta."))));
};
const Storage = (props) => {
    //const { history } = useReactRouter();
    const navigate = useNavigate();
    const classes = useStyles();
    const user = useUserContext().user;
    const { enqueueSnackbar } = useSnackbar();
    const { storageInfo, settings, api } = props;
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [unlocked, setUnlocked] = React.useState(false);
    const [lightOn, setLightOn] = React.useState(false);
    const canCancelSubscription = useMemo(() => hasPermission(Features.cancelSubscription, user), [user]);
    const canViewSubscriptions = useMemo(() => hasPermission(Features.viewSubscriptions, user), [user]);
    const canEditSubscriptions = useMemo(() => hasPermission(Features.editSubscriptions, user), [user]);
    const canUnlockStorage = useMemo(() => hasPermission(Features.unlockMyStorages, user), [user]);
    const canTurnOnLight = useMemo(() => hasPermission(Features.turnOnLight, user), [user]);
    const lockTimeout = useRef(null);
    const lightTimeout = useRef(null);
    const unlockStorage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (api) {
            try {
                yield api.unlockStorage(storageInfo.storageId, !unlocked);
                if (!unlocked) {
                    enqueueSnackbar(`Utrymmet är nu upplåst i ${getAppConfiguration().lockTimeout} sekunder`, {
                        variant: 'success',
                    });
                    setUnlocked(true);
                    lockTimeout.current = setTimeout(() => setUnlocked(false), 1000 * getAppConfiguration().lockTimeout);
                }
                else {
                    enqueueSnackbar('Utrymmet är nu låst', { variant: 'success' });
                    setUnlocked(false);
                    if (lockTimeout.current) {
                        clearTimeout(lockTimeout.current);
                        lockTimeout.current = null;
                    }
                }
            }
            catch (exception) {
                enqueueSnackbar('Någonting gick fel. Kunde inte låsa upp utrymmet', { variant: 'error' });
            }
        }
    });
    const turnOnLight = () => __awaiter(void 0, void 0, void 0, function* () {
        if (api) {
            try {
                yield api.turnOnLight(storageInfo.storageId, !lightOn);
                if (!lightOn) {
                    enqueueSnackbar(`Lampan är tänd i ${getAppConfiguration().lightTimeout / 60} minuter`, {
                        variant: 'success',
                    });
                    setLightOn(true);
                    lightTimeout.current = setTimeout(() => setLightOn(false), 1000 * getAppConfiguration().lightTimeout);
                }
                else {
                    enqueueSnackbar('Lampan är släckt', { variant: 'success' });
                    setLightOn(false);
                    if (lightTimeout.current) {
                        clearTimeout(lightTimeout.current);
                        lightTimeout.current = null;
                    }
                }
            }
            catch (exception) {
                enqueueSnackbar('Någonting gick fel. Kunde inte tända lampan', { variant: 'error' });
            }
        }
    });
    const navigateUsers = () => __awaiter(void 0, void 0, void 0, function* () {
        navigate(`/mypages/mystorage/${storageInfo.storageId}/users`);
    });
    const cancelSubscription = () => __awaiter(void 0, void 0, void 0, function* () {
        if (api && storageInfo && storageInfo.subscriptionId) {
            setLoading(true);
            try {
                yield api.cancelSubscription(storageInfo.subscriptionId);
                props.reloadInfo();
            }
            catch (error) {
                enqueueSnackbar('Någonting gick fel. Lyckades inte avsluta abonnemanget', { variant: 'error' });
            }
            finally {
                setLoading(false);
            }
        }
    });
    const isWithin3DaysBeforeExpiration = (expirationDate) => isAfter(add(new Date(), { days: 3 }), new Date(expirationDate));
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(GoBack, { to: "/mypages" }),
            React.createElement(Typography, { variant: "h1", sx: classes.title },
                storageInfo.containerCode,
                " - ",
                storageInfo.storageCode)),
        canViewSubscriptions &&
            ((storageInfo.cancelDate && storageInfo.expirationDate) || // TODO: This logic seems weird
                isWithin3DaysBeforeExpiration(storageInfo.expirationDate)) && (React.createElement(Box, { component: "div", sx: classes.expiring },
            React.createElement(WarningIcon, { sx: classes.icon }),
            React.createElement(Typography, null,
                "Ditt utrymme g\u00E5r ut den ",
                format(new Date(storageInfo.expirationDate), 'PP', { locale: sv })))),
        !storageInfo.rentalStarted && (React.createElement(Box, { component: "div", sx: classes.expiring },
            React.createElement(TimerIcon, { sx: classes.icon }),
            React.createElement(Typography, null,
                "Ditt utrymme blir tillg\u00E4ngligt",
                ' ',
                React.createElement(Box, { component: "span", sx: classes.bold }, format(new Date(storageInfo.startDate), 'PP', { locale: sv })),
                ' '))),
        React.createElement(Wrapper, null,
            React.createElement(Box, { component: "section", sx: classes.root },
                React.createElement(Box, { component: "div", sx: classes.options },
                    canUnlockStorage && (React.createElement(ButtonCard, { children: React.createElement(IconCard, { disabled: !storageInfo.rentalStarted, icon: (!unlocked && React.createElement(UnlockIcon, null)) || React.createElement(LockIcon, null), title: unlocked ? 'Lås' : 'Lås upp' }), disabled: !storageInfo.rentalStarted, onClick: unlockStorage })),
                    canTurnOnLight && (React.createElement(ButtonCard, { children: React.createElement(IconCard, { icon: (!lightOn && React.createElement(LampIcon, null)) || React.createElement(LampOffIcon, null), disabled: !storageInfo.rentalStarted, title: lightOn ? 'Släck lampan' : 'Tänd lampan' }), disabled: !storageInfo.rentalStarted, onClick: turnOnLight })),
                    storageInfo.subscriptionId && (React.createElement(React.Fragment, null,
                        React.createElement(ButtonCard, { disabled: !storageInfo.rentalStarted, children: React.createElement(IconCard, { disabled: !storageInfo.rentalStarted, icon: React.createElement(UserIcon, null), title: "Anv\u00E4ndare" }), onClick: navigateUsers }),
                        React.createElement(ButtonCard, { disabled: !storageInfo.rentalStarted, children: React.createElement(IconCard, { disabled: !storageInfo.rentalStarted, icon: React.createElement(ActivityIcon, null), title: "Se aktivitet" }), to: `/mypages/mystorage/${storageInfo.storageId}/activity` })))),
                canEditSubscriptions && (React.createElement(Settings, { setts: settings, storageInfo: props.storageInfo, loading: loading, hideCancel: !canCancelSubscription, cancelDate: storageInfo.cancelDate, expirationDate: storageInfo.expirationDate, onClickCancel: () => setOpen(true) })))),
        storageInfo.subscriptionId && (React.createElement(ConfirmDialog, { subsId: storageInfo.subscriptionId, open: open, onConfirm: cancelSubscription, expirationDate: storageInfo.expirationDate, closeDialog: () => setOpen(false) }))));
};
export const MyStorage = () => {
    const api = useApi();
    const abortController = useApiAbort();
    if (api) {
        api.setAbortController(abortController.current);
    }
    const { storageId } = useParams();
    const storageIdConverted = parseInt(storageId);
    const [storageInfo, loading, reloadInfo] = useApiFetch(useCallback(() => fetchStorageInfo(api, storageIdConverted), [api, storageIdConverted]), undefined, errorInfo, abortController.current);
    if (storageId === undefined || storageInfo === errorInfo) {
        return React.createElement(HTTP401, null);
    }
    return (React.createElement(Transition, { isLoading: storageInfo === undefined || loading },
        React.createElement(RouterSwitch, null,
            React.createElement(Route, { path: "/activity", element: (storageInfo && (React.createElement(StorageActivity, { storageId: storageIdConverted, storageCode: storageInfo.storageCode, containerCode: storageInfo.containerCode }))) || React.createElement(React.Fragment, null) }),
            React.createElement(Route, { path: "/users", element: (storageInfo && React.createElement(StorageUsers, { storageId: storageIdConverted })) || React.createElement(React.Fragment, null) }),
            React.createElement(Route, { path: "/", element: (storageInfo && (React.createElement(Storage, { storageInfo: storageInfo, reloadInfo: reloadInfo, settings: [], api: api }))) || React.createElement(React.Fragment, null) }))));
};
export default MyStorage;
